var map = {
	"./basketball-active.webp": 1540,
	"./basketball.webp": 1541,
	"./bg.webp": 1542,
	"./football-active.webp": 1543,
	"./football.webp": 1544,
	"./games-active.webp": 1545,
	"./games.webp": 1546,
	"./live-streaming-cover.webp": 1547,
	"./lv-active-bg.webp": 1548,
	"./video-bg.webp": 1549,
	"./video-icon.webp": 1550,
	"./vs.webp": 1551
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 462;